import React, { Component } from "react";
import { Link } from "react-router-dom";
//import Social from "../section-components/social";
import Copyright from "./copyright";

class Footer_v1 extends Component {
  componentDidMount() {
    const $ = window.$;

    let publicUrl = process.env.PUBLIC_URL + "/";
    const minscript = document.createElement("script");
    minscript.async = true;
    minscript.src = publicUrl + "assets/js/main.js";

    document.body.appendChild(minscript);

    $(".go-top")
      .find("a")
      .on("click", function () {
        $(".quarter-overlay").fadeIn(1);

        $(window).scrollTop(0);

        setTimeout(function () {
          $(".quarter-overlay").fadeOut(300);
        }, 800);
      });

    $(document).on("click", ".theme-btn-1 ", function () {
      $("div").removeClass("modal-backdrop");
      $("div").removeClass("show");
      $("div").removeClass("fade");
      $("body").attr("style", "");
    });
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
   

    return (
      <footer className="ltn__footer-area bg-black ">
        <div className="footer-top-area bg-black section-bg-2 plr--5">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-3 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-about-widget">
                  <div className="footer-logo">
                    <div className="site-logo">
                      <img
                        width={170}
                        height={150}
                        src={publicUrl + "assets/img/logo1.jpg"}
                        alt="شعار"
                      />
                    </div>
                  </div>
                  <div className="footer-address">
                    <ul>
                      <li>
                        <div className="footer-address-icon">
                          <i className="icon-placeholder" />
                        </div>
                        <div className="footer-address-info">
                          <p>مصر، القاهرة</p>
                        </div>
                      </li>
                      <li>
                        <div className="footer-address-icon">
                        </div>
                        <div className="footer-address-info">
                          <p>
                            <i className="icon-call" />
                            <a href="tel:+01120761611">01120761611</a>
                          </p>
                          <p>
                            <i className="icon-call" />
                            <a href="tel:+01092952221">01092952221</a>
                          </p>
                          <p>
                            <i className="icon-call" />
                            <a href="tel:+01028998815">01028998815</a>
                          </p>
                        </div>
                      </li>
                      <li>
                        <div className="footer-address-icon">
                          <i className="icon-mail" />
                        </div>
                        <div className="footer-address-info">
                          <p>
                            <a href="mailto:mohamed.aboseada@offices.net?Subject=Flower%20greetings%20to%20you">
                              mohamed.aboseada@offices.net
                            </a>
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="ltn__social-media mt-20">
                   {/*<Social />*/} 
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">المكتب</h4>
                  <div className="footer-menu go-top">
                    <ul>
                      <li>
                        <Link to="/arabout">عنا</Link>
                      </li>
                      <li>
                        <Link to="/arservice">خدمات</Link>
                      </li>
                      <li>
                        <Link to="/contact">اتصل بنا</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              
              <div className="col-xl-2 col-md-6 col-sm-6 col-12">
                <div className="footer-widget footer-menu-widget clearfix">
                  <h4 className="footer-title">خدمة العملاء</h4>
                  <div className="footer-menu go-top">
                    <ul>
                      <li>
                        <Link to="/contact">اتصل بنا</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6 col-sm-12 col-12">
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer_v1;
